module.exports = __webpack_public_path__ + "img/document-plus.bdb34a84.svg";